module.exports = __webpack_public_path__ + "media/6.6eab934f.wav";